import cronstrue from 'cronstrue';
import emojiRegexLib from 'emoji-regex-xs';
import { DEFAULT_IGNORED_LOOKER_URL_PARAMS } from './consts';

export const extractCronText = (value: string): string => {
  if (!value) return '';
  return cronstrue.toString(value, { verbose: true });
};

export function sanitizeLookmlValue(value: string): string {
  if (value === null || value === undefined || typeof value !== 'string') {
    return '';
  }

  let sanitized = value;

  // 1. Remove multi-character SQL comment markers and statement separator first
  //    Order matters to avoid creating sequences by removing single characters.
  sanitized = sanitized.replace(/--/g, ''); // Remove -- (SQL line comment)
  sanitized = sanitized.replace(/\/\*/g, ''); // Remove /* (SQL block comment start)
  sanitized = sanitized.replace(/\*\//g, ''); // Remove */ (SQL block comment end)

  // 2. Remove single characters often problematic in Liquid, SQL, LookML filters
  //    Includes { } % $ ^ ; \
  //    Using a regex character class `[]`. Note `\` needs to be escaped as `\\`.
  const problematicSingleCharsRegex = /[{}%$^;\\]/g;
  sanitized = sanitized.replace(problematicSingleCharsRegex, '');

  // 3. Remove the literal word NULL (case-insensitive, ensuring it's a whole word)
  //    \b denotes a word boundary.
  const nullRegex = /\bNULL\b/gi;
  sanitized = sanitized.replace(nullRegex, '');

  // 4. Remove basic ASCII control characters (U+0000 to U+001F), except for
  //    tab (U+0009), line feed (U+000A), and carriage return (U+000D)
  //    which are often handled by whitespace normalization later.
  sanitized = sanitized.replace(
    // biome-ignore lint/suspicious/noControlCharactersInRegex: non-issue
    /[\u0000-\u0008\u000B\u000C\u000E-\u001F]/g,
    '',
  );

  // 5. Normalize whitespace: replace multiple whitespace chars (including newlines, tabs)
  //    with a single space, then trim leading/trailing whitespace.
  sanitized = sanitized.replace(/\s+/g, ' ').trim();

  return sanitized;
}

export const sanitizeFilterExpression = (value: string) => {
  const regex = emojiRegexLib();
  let sanitizedValue = value.replace(regex, '');

  sanitizedValue = sanitizeLookmlValue(sanitizedValue);

  return sanitizedValue.trim();
};

export function parseQueryParams<T extends Record<string, string>>(
  search: string,
  ignoredKeys: readonly string[] = DEFAULT_IGNORED_LOOKER_URL_PARAMS,
): T {
  const searchParams = new URLSearchParams(search);

  for (const key of ignoredKeys) {
    searchParams.delete(key);
  }

  return Object.fromEntries(searchParams.entries()) as T;
}
